import React, { useState, useEffect } from "react";
import giftCard from "../../../assets/images/media/gift_card.svg";
import api from "../../../api";
import Swal from "sweetalert2";
import Spinner from "../../LoadingSpinner/loadingSpinner";
import { lang } from "moment/moment";

const Loyalty = ({ loyaltyprograms, loyaltyPoints = 0 }) => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);

  const points = loyaltyPoints;
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  const maxPoints = 100;
  const percentage = Math.min(Math.round((points / maxPoints) * 100), 100);
  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "00:00:00";

    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");

    return `${h}:${m}:${s}`;
  };
  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec)) return "00:00:00";

    const hrs = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const secs = String(sec % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };

  const takeLoyality = async (reward) => {
    try {
      setLoading(true);
      const response = await api.post(`/services/take-loyalty-reward`, {
        reward_id: reward.id,
      });
      const responseData = response.data?.data || {};
      const paymentUrl = responseData.payment_url;
      const addedCredits = responseData.added_credits || [];
      if (
        (reward.type === "discount" || reward.type === "package") &&
        paymentUrl
      ) {
        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          paymentUrl,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );

        return;
      }

      if (addedCredits) {
        const creditsHtml = addedCredits
          .map((credit) => {
            if (
              credit.unit === "period" &&
              credit.communication_type === "call"
            ) {
              return `
        <li className="flex align-items-center justify-content-center gap-1 mb-2">
          <i className="bi bi-telephone-fill"></i>
          ${formatTime(credit.credit)}
          ${languageData.call}
        </li>
      `;
            }

            if (credit.communication_type === "email") {
              return `
        <li className="flex align-items-center justify-content-center gap-1 mb-2">
          <i className="bi bi-envelope-fill"></i>
          ${credit.credit} emails
        </li>
      `;
            }

            if (credit.communication_type === "chat") {
              return `
        <li className="flex align-items-center justify-content-center gap-1 mb-2">
          <i className="bi bi-chat-fill"></i>
          ${credit.credit} messages
        </li>
      `;
            }

            return "";
          })
          .join("");

        await Swal.fire({
          icon: "success",
          title: languageData.alert.success.title,
          html: `
            <p className="fs-16">${languageData.alert.success.description}</p>
            <ul className="font-16 flex flex-column align-items-center justify-content-center">
              ${creditsHtml}
            </ul>
          `,
          confirmButtonText: "OK",
        });
      } else {
        const result = await Swal.fire({
          icon: "success",
          title: languageData.free_reward_success,
          confirmButtonText: languageData.go_payment,
        });
        if (result.isConfirmed) {
          const width = 800;
          const height = 900;
          const left = window.screenX + (window.outerWidth - width) / 2;
          const top = window.screenY + (window.outerHeight - height) / 2;
          window.open(
            paymentUrl,
            "PaymentWindow",
            `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
          );
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: languageData.alert.something_went_wrong.title,
        text:
          error?.response?.data?.message ||
          languageData.alert.something_went_wrong.description,
      });
    } finally {
      setLoading(false);
    }
  };
  const getRuleText = (rule) => {
    const currencyMap = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };

    if (rule.trigger === "review") {
      return (
        <>
          {languageData.tab_loyalty.write_reviews}{" "}
          <strong>
            {rule.threshold} {languageData.tab_loyalty.comments}
          </strong>{" "}
          {languageData.tab_loyalty.win} <strong>{rule.points}</strong>{" "}
          {languageData.tab_loyalty.point}
        </>
      );
    }

    if (rule.trigger === "order") {
      if (rule.unit === "total_amount") {
        return (
          <>
            {languageData.tab_loyalty.spend}{" "}
            <strong>
              {rule.threshold} {currencyMap[rule.currency]}{" "}
              {languageData.tab_loyalty.total_achat}
            </strong>{" "}
            {languageData.tab_loyalty.win} <strong>{rule.points}</strong>{" "}
            {languageData.tab_loyalty.point}
          </>
        );
      }

      if (rule.unit === "quantity") {
        return (
          <>
            {languageData.tab_loyalty.buy}{" "}
            <strong>
              {rule.threshold} {languageData.tab_loyalty.commande}{" "}
            </strong>
            {languageData.tab_loyalty.win} <strong>{rule.points}</strong>{" "}
            {languageData.tab_loyalty.point}
          </>
        );
      }
    }

    return "";
  };
  const appName = process.env.REACT_APP_NAME;
  const currencyMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };
  const replaceEnv = (text) => {
    return text.replace(/{{APP_NAME}}/g, appName);
  };
  if (!languageData) {
    return <div></div>;
  }
  return (
    <div
      className="tab-pane fade p-0 border-0 active show"
      id="loyalty-tab-pane"
      role="tabpanel"
      aria-labelledby="loyalty-tab"
      tabIndex="0"
    >
      <div className="card-body text-center">
        <div className="text-center mb-2">
          <span className="avatar avatar-xxxxl">
            <img src={giftCard} alt="Gift Card" />
          </span>
        </div>
        <div className="fs-23 fw-semibold mb-3">
          {languageData.tab_loyalty.title}{" "}
          <b className="text-success">{languageData.tab_loyalty.rewarded}</b>
        </div>
        <div className="text-muted fs-14 px-4 mb-3">
          {replaceEnv(languageData.tab_loyalty.description)}
        </div>
        {loyaltyprograms.length > 0 && (
          <div className="card custom-card border mt-6">
            <div className="card-header">
              <div className="card-title">
                <i className="bx bx-gift me-2"></i>
                {languageData.tab_loyalty.loyalty}
              </div>
            </div>
            {loyaltyprograms?.map((program) => {
              const maxRequiredPoints = Math.max(
                ...(program.rewards?.map(
                  (r) => Number(r.required_points) || 0,
                ) || []),
              );
              const grouped = (program.rewards || []).reduce((acc, reward) => {
                const key = reward.required_points;

                if (!acc[key]) acc[key] = [];

                acc[key].push(reward);

                return acc;
              }, {});
              const uniqueProgressRewards = Object.values(grouped)
                .map((list) => {
                  return list.find((r) => r.type !== "free_product") || list[0];
                })
                .sort(
                  (a, b) => parseFloat(b.progress) - parseFloat(a.progress),
                );

              const rewardColorIndexMap = uniqueProgressRewards.reduce(
                (acc, reward, index) => {
                  acc[reward.required_points] = index;
                  return acc;
                },
                {},
              );

              const progressColors = [
                "bg-primary",
                "bg-second",
                "bg-warning",
                "bg-info",
                "bg-danger",
                "bg-secondary",
              ];
              const sortedRewards = [...(program.rewards || [])].sort(
                (a, b) => {
                  if (a.type === "free_product" && b.type !== "free_product")
                    return 1;
                  if (a.type !== "free_product" && b.type === "free_product")
                    return -1;

                  return Number(a.required_points) - Number(b.required_points);
                },
              );

              return (
                <div className="card-body border-end">
                  <div className="d-sm-flex mb-3">
                    <div className="me-sm-2 mb-2 mb-sm-0">
                      <div className="avatar bg-primary-transparent text-primary br-5 fs-22">
                        <i className="bx bx-category"></i>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex-between mb-1">
                        <p className="mb-0 fs-14">
                          {languageData.tab_loyalty.points}
                        </p>
                      </div>
                      <h5 className="mb-0 text-start">
                        <span className="tx-muted tx-13">
                          {" "}
                          {points} / {maxRequiredPoints}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div className="flex flex-column gap-4">
                    <div>
                      {uniqueProgressRewards.map((reward) => {
                        const index =
                          rewardColorIndexMap[reward.required_points];
                        return (
                          <div>
                            <span className="flex justify-content-end">
                              {reward.required_points}{" "}
                              {languageData.tab_loyalty.point}
                            </span>
                            <div
                              key={reward.id}
                              className="progress progress-xl mb-4 position-relative"
                            >
                              <div
                                className={`progress-bar ${progressColors[index % progressColors.length]}`}
                                style={{
                                  width: `${parseFloat(reward.progress)}%`,
                                  minWidth:
                                    parseFloat(reward.progress) === 0
                                      ? "100%"
                                      : "auto",
                                  opacity:
                                    parseFloat(reward.progress) === 0 ? 0.2 : 1,
                                }}
                              >
                                {parseFloat(reward.progress) > 0 && (
                                  <span>{parseFloat(reward.progress)}%</span>
                                )}
                              </div>

                              {/* 👇 centered label when 0% */}
                              {parseFloat(reward.progress) === 0 && (
                                <span className="position-absolute w-100 text-center empty_progress">
                                  0%
                                </span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                      <h5 className="text-start fs-16 mb-0">
                        {languageData.tab_loyalty.renumeration}
                      </h5>
                      <div className="flex gap-3 flex-wrap m-10">
                        {sortedRewards.map((reward) => {
                          const currency = currencyMap[reward.currency];

                          return (
                            <div className="card_rewards" key={reward.id}>
                              {reward.type === "discount" && (
                                <div className="badge_rewards">
                                  <>-{parseFloat(reward.discounts?.value)}%</>
                                </div>
                              )}
                              <div className="info">
                                <div className="cat">
                                  {reward.type === "discount"
                                    ? languageData.tab_loyalty.discount
                                    : reward.type === "package"
                                      ? languageData.tab_loyalty.package
                                      : languageData.tab_loyalty.free_product}
                                </div>
                                {reward.packages?.map((pkg) => (
                                  <div key={pkg.id} className="package-block">
                                    <h2 className="title">{pkg.name}</h2>

                                    <p className="desc">
                                      {pkg.items?.map((item) => {
                                        const duration =
                                          item.unit === "period"
                                            ? formatDuration(item.size)
                                            : item.size;

                                        const label =
                                          item.unit === "period"
                                            ? languageData.tab_loyalty.call
                                            : languageData.tab_loyalty.message;

                                        return (
                                          <span
                                            key={item.id}
                                            className="d-block"
                                          >
                                            {duration} {label}
                                          </span>
                                        );
                                      })}
                                    </p>
                                    <div className="bottom">
                                      <div className="pric">
                                        {reward.type === "discount" && (
                                          <>
                                            <span className="old">
                                              {parseFloat(reward.price)}
                                              {currency}
                                            </span>

                                            <span className="new ">
                                              {parseFloat(
                                                reward.discounted_price,
                                              )}
                                              {currency}
                                            </span>
                                          </>
                                        )}
                                        {reward.type === "free_product" && (
                                          <span className="new text-decoration-line-through">
                                            {parseFloat(reward.price)}
                                            {currency}
                                          </span>
                                        )}
                                      </div>
                                      {Number(reward.available_usage) > 0 && (
                                        <button
                                          data-interaction="take_loyalty_button"
                                          className={`btn`}
                                          onClick={() => takeLoyality(reward)}
                                        >
                                          {reward.type === "discount"
                                            ? languageData.tab_loyalty
                                                .discount_btn
                                            : reward.type === "package"
                                              ? languageData.tab_loyalty
                                                  .package_btn
                                              : languageData.tab_loyalty
                                                  .free_btn}
                                        </button>
                                      )}
                                    </div>
                                    {pkg.validity &&
                                      !["infinite", "null", ""].includes(
                                        String(pkg.validity).toLowerCase(),
                                      ) && (
                                        <div className="meta">
                                          <span className="rcount">
                                            {
                                              languageData.tab_loyalty.validity
                                                .subtitle
                                            }{" "}
                                            {pkg.validity === "one_month"
                                              ? languageData.tab_loyalty
                                                  .validity.one_month
                                              : pkg.validity === "one_day"
                                                ? languageData.tab_loyalty
                                                    .validity.one_day
                                                : pkg.validity === "one_year"
                                                  ? languageData.tab_loyalty
                                                      .validity.one_year
                                                  : ""}
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                ))}
                                {reward.type === "package" && (
                                  <span className="new">
                                    {reward.price}
                                    {currencyMap[reward.currency]}
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })}{" "}
                        {/*  {sortedRewards.map((reward) => {
                        const currency = currencyMap[reward.currency];

                        return reward.packages?.map((pkg) => (
                          <div
                            className="card_rewards"
                            key={`${reward.id}-${pkg.id}`}
                          >
                            <div className="badge_rewards">
                              {reward.type === "discount"
                                ? languageData.tab_loyalty.discount
                                : reward.type === "package"
                                  ? languageData.tab_loyalty.package
                                  : languageData.tab_loyalty.free_product}
                            </div>

                            <div className="info">
                              <div className="cat">
                                {reward.type === "discount"
                                  ? languageData.tab_loyalty.discount
                                  : reward.type === "package"
                                    ? languageData.tab_loyalty.package
                                    : languageData.tab_loyalty.free_product}
                              </div>

                              <h2 className="title">{pkg.name}</h2>

                              <p className="desc">
                                {pkg.items?.map((item) => {
                                  const duration =
                                    item.unit === "period"
                                      ? formatDuration(item.size)
                                      : item.size;

                                  const label =
                                    item.unit === "period"
                                      ? languageData.tab_loyalty.call
                                      : languageData.tab_loyalty.message;

                                  return (
                                    <span key={item.id} className="d-block">
                                      {duration} {label}
                                    </span>
                                  );
                                })}
                              </p>

                              <div className="bottom">
                                <div className="pric">
                                  {reward.type === "discount" && (
                                    <>
                                      <span className="new text-decoration-line-through">
                                        {parseFloat(reward.price)}
                                        {currency}
                                      </span>
                                    </>
                                  )}

                                  {reward.type === "package" &&
                                    pkg.items?.map((item) => (
                                      <span className="new" key={item.id}>
                                        {parseFloat(item.price)}
                                        {currencyMap[item.currency]}
                                      </span>
                                    ))}

                                  {reward.type === "free_product" && (
                                    <>
                                      <span className="old">
                                        {parseFloat(reward.price)}
                                        {currency}
                                      </span>
                                    </>
                                  )}
                                </div>

                                {Number(reward.available_usage) > 0 && (
                                  <button
                                    data-interaction="take_loyalty_button"
                                    className={`btn `}
                                    onClick={() => takeLoyality(reward)}
                                  >
                                    <span>
                                      {reward.type === "discount"
                                        ? languageData.tab_loyalty.discount_btn
                                        : reward.type === "package"
                                          ? languageData.tab_loyalty.package_btn
                                          : languageData.tab_loyalty.free_btn}
                                    </span>
                                  </button>
                                )}
                              </div>
                              {pkg.validity &&
                                !["infinite", "null", ""].includes(
                                  String(pkg.validity).toLowerCase(),
                                ) && (
                                  <div class="meta">
                                    <div class="rating">
                                      <span class="rcount">
                                        {
                                          languageData.tab_loyalty.validity
                                            .subtitle
                                        }{" "}
                                        {pkg.validity === "one_month"
                                          ? languageData.tab_loyalty.validity
                                              .one_month
                                          : pkg.validity === "one_day"
                                            ? languageData.tab_loyalty.validity
                                                .one_day
                                            : pkg.validity === "one_year"
                                              ? languageData.tab_loyalty
                                                  .validity.one_year
                                              : ""}
                                      </span>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        ));
                      })} */}
                      </div>
                      {/*  {sortedRewards.map((reward, index) => {
                      const discount = reward.discounts?.value;
                      const currencyMap = {
                        EUR: "€",
                        USD: "$",
                        GBP: "£",
                      };
                      const price = Number(reward.price);
                      const packageContent = reward.packages?.map(
                        (pkg, pkgIndex) => {
                          return (
                            <span key={pkg.id}>
                              {pkg.items?.map((item, itemIndex) => {
                                const duration =
                                  item.unit === "period"
                                    ? formatDuration(item.size)
                                    : item.size;

                                const label =
                                  item.unit === "period"
                                    ? languageData.tab_loyalty.call
                                    : languageData.tab_loyalty.message;
                                return (
                                  <span key={item.id}>
                                    ({duration} {label})
                                  </span>
                                );
                              })}
                            </span>
                          );
                        },
                      );
                      const colorIndex =
                        rewardColorIndexMap?.[reward.required_points] ?? 0;

                      const iconClass =
                        reward.type === "free_product"
                          ? "text-success"
                          : progressColors[
                              colorIndex % progressColors.length
                            ].replace("bg-", "text-");
                      const colorMap = {
                        primary: "primary",
                        second: "second",
                        warning: "warning",
                        info: "info",
                        danger: "danger",
                        secondary: "secondary",
                      };

                      const normalizeColor = (bgClass) =>
                        bgClass.replace("bg-", "");
                      const getButtonClass = (reward) => {
                        if (reward.type === "free_product")
                          return "btn-success";

                        const index =
                          rewardColorIndexMap?.[reward.required_points] ?? 0;

                        const bg =
                          progressColors[index % progressColors.length];
                        const key = normalizeColor(bg);

                        return `btn-${colorMap[key] || "primary"}`;
                      };
                      return (
                        <span className="fs-14 d-block d-flex gap-1 align-items-center flex-wrap justify-content-between">
                          <div className="fs-14 mt-2 d-block d-flex gap-1 align-items-center flex-wrap">
                            <i
                              className={`bx bxs-circle tx-8 ${iconClass}`}
                            ></i>
                            <span
                              key={`-${reward.id}`}
                              className="d-flex align-items-baseline gap-1 flex-wrap"
                            >
                              {reward.type === "discount" && (
                                <div className="d-flex gap-1 align-items-center flex-wrap">
                                  <span>
                                    {languageData.tab_loyalty.discount}
                                  </span>
                                  <span className="discount_price">
                                    -{parseFloat(discount)}%
                                  </span>
                                  <span>
                                    {languageData.tab_loyalty.on_pack}
                                  </span>
                                  <div className="d-flex flex-wrap gap-1">
                                    {reward.packages?.map((pkg, index) => (
                                      <div className="flex align-items-center gap-1 flex-wrap">
                                        <span className="fs-12 d-flex flex-column gap-1 align-items-start fw-500 pack_name">
                                          <span key={pkg.id}>{pkg.name}</span>
                                            <span key={pkg.id}>
                                          {pkg.items?.map((item, itemIndex) => {
                                            const duration =
                                              item.unit === "period"
                                                ? formatDuration(item.size)
                                                : item.size;

                                            const label =
                                              item.unit === "period"
                                                ? languageData.tab_loyalty.call
                                                : languageData.tab_loyalty
                                                    .message;
                                            return (
                                              <span key={item.id}>
                                                ({duration} {label})
                                              </span>
                                            );
                                          })}
                                        </span>
                                        </span>
                                      
                                     
                                        {pkg.validity &&
                                          !["infinite", "null", ""].includes(
                                            String(pkg.validity).toLowerCase(),
                                          ) && (
                                            <span className="validity_label">
                                              {
                                                languageData.tab_loyalty
                                                  .validity.subtitle
                                              }{" "}
                                              {pkg.validity === "one_month"
                                                ? languageData.tab_loyalty
                                                    .validity.one_month
                                                : pkg.validity === "one_day"
                                                  ? languageData.tab_loyalty
                                                      .validity.one_day
                                                  : pkg.validity === "one_year"
                                                    ? languageData.tab_loyalty
                                                        .validity.one_year
                                                    : ""}
                                            </span>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                  <strong className="fs-15 green">
                                    {" "}
                                    {parseFloat(reward.discounted_price)}
                                    {currencyMap[reward.currency]}
                                  </strong>
                                  <span>
                                    {languageData.tab_sponsorship.instead_of}
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <span className="discounted_price text-decoration-line-through">
                                      {parseFloat(reward.price)}
                                      {currencyMap[reward.currency]}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {reward.type === "package" && (
                                <div className="d-flex gap-1 align-items-center flex-wrap">
                                  <span>
                                    {languageData.tab_loyalty.package}
                                  </span>

                                  <div className="d-flex flex-wrap gap-1">
                                    {reward.packages?.map((pkg, index) => (
                                      <div className="flex align-items-center gap-1 flex-wrap">
                                        <span className="fs-12 d-flex flex-column gap-1 align-items-start fw-500 pack_name">
                                          <span key={pkg.id}>{pkg.name}</span>
                                            <span key={pkg.id}>
                                          {pkg.items?.map((item, itemIndex) => {
                                            const duration =
                                              item.unit === "period"
                                                ? formatDuration(item.size)
                                                : item.size;

                                            const label =
                                              item.unit === "period"
                                                ? languageData.tab_loyalty.call
                                                : languageData.tab_loyalty
                                                    .message;
                                            return (
                                              <span key={item.id}>
                                                ({duration} {label})
                                              </span>
                                            );
                                          })}
                                        </span>
                                        </span>
                                      
                                        {reward.type === "package" &&
                                          pkg.items?.map((item) => (
                                            <span key={`price-${item.id}`}>
                                              {parseFloat(item.price)}
                                              {currencyMap[item.currency]}
                                            </span>
                                          ))}
                                      
                                        {pkg.validity &&
                                          !["infinite", "null", ""].includes(
                                            String(pkg.validity).toLowerCase(),
                                          ) && (
                                            <span className="validity_label">
                                              {
                                                languageData.tab_loyalty
                                                  .validity.subtitle
                                              }{" "}
                                              {pkg.validity === "one_month"
                                                ? languageData.tab_loyalty
                                                    .validity.one_month
                                                : pkg.validity === "one_day"
                                                  ? languageData.tab_loyalty
                                                      .validity.one_day
                                                  : pkg.validity === "one_year"
                                                    ? languageData.tab_loyalty
                                                        .validity.one_year
                                                    : ""}
                                            </span>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {reward.type === "free_product" && (
                                <div className="d-flex gap-1 align-items-center flex-wrap">
                                  <span>
                                    {languageData.tab_loyalty.free_product}
                                  </span>

                                  <div className="d-flex flex-wrap gap-1">
                                    {reward.packages?.map((pkg, index) => (
                                      <div className="flex align-items-center gap-1 flex-wrap">
                                        <span className="fs-12 d-flex flex-column gap-1 align-items-start fw-500 pack_name">
                                          <span key={pkg.id}>{pkg.name}</span>
                                             <span key={pkg.id}>
                                          {pkg.items?.map((item, itemIndex) => {
                                            const duration =
                                              item.unit === "period"
                                                ? formatDuration(item.size)
                                                : item.size;

                                            const label =
                                              item.unit === "period"
                                                ? languageData.tab_loyalty.call
                                                : languageData.tab_loyalty
                                                    .message;
                                            return (
                                              <span key={item.id}>
                                                ({duration} {label})
                                              </span>
                                            );
                                          })}
                                        </span>
                                        </span>
                                     
 <div className="d-flex align-items-center">
                                    <span className="discounted_price text-decoration-line-through">
                                      {parseFloat(reward.price)}
                                      {currencyMap[reward.currency]}
                                    </span>
                                  </div>
                                        {pkg.validity &&
                                          !["infinite", "null", ""].includes(
                                            String(pkg.validity).toLowerCase(),
                                          ) && (
                                            <span className="validity_label">
                                              {
                                                languageData.tab_loyalty
                                                  .validity.subtitle
                                              }{" "}
                                              {pkg.validity === "one_month"
                                                ? languageData.tab_loyalty
                                                    .validity.one_month
                                                : pkg.validity === "one_day"
                                                  ? languageData.tab_loyalty
                                                      .validity.one_day
                                                  : pkg.validity === "one_year"
                                                    ? languageData.tab_loyalty
                                                        .validity.one_year
                                                    : ""}
                                            </span>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                 
                                </div>
                              )}
                            </span>
                          </div>
                          {Number(reward.available_usage) > 0 && (
                            <button
                              data-interaction="take_loyalty_button"
                              className={`btn ${getButtonClass(reward)} btn-sm me-2`}
                              onClick={() => takeLoyality(reward)}
                            >
                              {reward.type === "free_product"
                                ? languageData.tab_loyalty.free_btn
                                : reward.type === "discount"
                                  ? languageData.tab_loyalty.discount_btn
                                  : reward.type === "package"
                                    ? languageData.tab_loyalty.package_btn
                                    : languageData.tab_loyalty.buy}
                            </button>
                          )}
                        </span>
                      );
                    })} */}
                    </div>
                    <div>
                      {program.rules?.length > 0 && (
                        <>
                          <h5 className="mb-0 text-start fs-16">
                            {languageData.tab_loyalty.subtitle}
                          </h5>
                          <div className="flex flex-column align-items-start gap-2 mt-2">
                            {program.rules?.map((rule) => (
                              <span
                                className="d-flex align-items-center gap-1 rules"
                                key={rule.id}
                              >
                                <i class="bx bxs-circle tx-8 fs-11"></i>

                                <span className="text-start">
                                  {getRuleText(rule)}
                                </span>
                              </span>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Loyalty;
